import 'babel-polyfill'
// Side-effect import: extends dayjs with the plugins aqe components depend on
// (localizedFormat, customParseFormat, utc, timezone, etc.). Must run before
// any aqe component module evaluates so dayjs is ready when AntD v6 pickers
// format dates with localized tokens like 'LL'.
import '@pushly/aqe/lib/dayjs-setup'
import React from 'react'
import * as ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import Halo from '@halo/halo'
import { Maintenance503 } from '@halo/components/http-code-pages'
import { setupAxios } from '@halo/_utils/axios'
import { setupAqe } from '@halo/_utils/aqe'
import { UserProvider } from '@halo/providers/user-provider/user-provider'

setupAqe()
setupAxios()

let AppComponent: any = Halo
if (process.env.MAINT_MODE === 'on') {
    AppComponent = Maintenance503
}

const container = document.getElementById('halo')
ReactDOM.createRoot(container).render(
    <BrowserRouter>
        <UserProvider>
            <AppComponent />
        </UserProvider>
    </BrowserRouter>,
)
